/**
 * ChartMind Gemini Live monolingual scribe path.
 * On by default; set REACT_APP_CHARTMIND_LIVE_RECORDING_DISABLED=true to turn off.
 * Separate from interpreter flags.
 *
 * {@link isChartMindGeminiLiveUngatedForTrials} ignores DISABLED during local dev / DEV_UNGATED.
 */

import { isChartMindGeminiLiveUngatedForTrials } from './chartmindGeminiLiveDevTrialMode';

export const isChartMindLiveRecordingFeatureEnabled = () => {
  if (isChartMindGeminiLiveUngatedForTrials()) return true;
  if (typeof process !== 'undefined' && process.env.REACT_APP_CHARTMIND_LIVE_RECORDING_DISABLED === 'true') {
    return false;
  }
  return true;
};
